import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#049CE4',
                secondary: '#1D212D',
                accent: '#00497F',
                error: '#E40414',
                background:"#fcfcfc"
            },
            dark:{
                primary: '#025e89',
                secondary: '#002c4c',
                accent:"#002c4c",
                error:'#89020c"',
                background:"#1e1e1e"           
            },
            options: {
                customProperties: true
            },
        },
    }
});